import { useTranslations } from '@aikoa/i18n/react'
import { Link } from 'expo-router'
import { View } from 'react-native'
import ContentBox from '~/components/layout/ContentBox'
import ScreenView from '~/components/layout/ScreenView'
import { ViewTitle } from '~/components/layout/Sections'
import { Label } from '~/components/typography/Content'
import { Button, ButtonLabel } from '~/components/ui/button'

export default function AdminIndex() {
  const { t } = useTranslations('admin')

  return (
    <ScreenView>
      <ContentBox>
        <ViewTitle>{t(($) => $.title)}</ViewTitle>
        <View className="mt-6 gap-6">
          <View className="gap-3">
            <Label className="text-secondary">{t(($) => $.sections.users)}</Label>
            <Link href="/(authenticated)/admin/users" asChild>
              <Button variant="outline">
                <ButtonLabel>{t(($) => $.users.title)}</ButtonLabel>
              </Button>
            </Link>
            <Link href="/(authenticated)/admin/organisations" asChild>
              <Button variant="outline">
                <ButtonLabel>{t(($) => $.organisations.title)}</ButtonLabel>
              </Button>
            </Link>
            <Link href="/(authenticated)/admin/contact-requests" asChild>
              <Button variant="outline">
                <ButtonLabel>{t(($) => $.contactRequests.title)}</ButtonLabel>
              </Button>
            </Link>
            <Link href="/(authenticated)/admin/invitations" asChild>
              <Button variant="outline">
                <ButtonLabel>{t(($) => $.invitations.title)}</ButtonLabel>
              </Button>
            </Link>
            <Link href="/(authenticated)/admin/users/add" asChild>
              <Button variant="outline">
                <ButtonLabel>{t(($) => $.createUser.button)}</ButtonLabel>
              </Button>
            </Link>
          </View>

          <View className="gap-3">
            <Label className="text-secondary">{t(($) => $.sections.billing)}</Label>
            <Link href="/(authenticated)/admin/promotions" asChild>
              <Button variant="outline">
                <ButtonLabel>{t(($) => $.promotions.title)}</ButtonLabel>
              </Button>
            </Link>
          </View>

          <View className="gap-3">
            <Label className="text-secondary">Feedback</Label>
            <Link href="/(authenticated)/admin/feedback-stats" asChild>
              <Button variant="outline">
                <ButtonLabel>Feedback Stats</ButtonLabel>
              </Button>
            </Link>
          </View>

          <View className="gap-3">
            <Label className="text-secondary">{t(($) => $.sections.tools)}</Label>
            <Link href="/(authenticated)/admin/workflow-runs" asChild>
              <Button variant="outline">
                <ButtonLabel>Workflow-ajot</ButtonLabel>
              </Button>
            </Link>
            <Link href="/(authenticated)/admin/bulk-feedback-import" asChild>
              <Button variant="outline">
                <ButtonLabel>Massapalaute CSV-tuonti</ButtonLabel>
              </Button>
            </Link>
            <Link href="/(authenticated)/admin/bulk-realtor-import" asChild>
              <Button variant="outline">
                <ButtonLabel>Välittäjien aktivointi CSV-tuonti</ButtonLabel>
              </Button>
            </Link>
            <Link href="/(authenticated)/admin/template-translations" asChild>
              <Button variant="outline">
                <ButtonLabel>Käännösten muokkaus</ButtonLabel>
              </Button>
            </Link>
          </View>
        </View>
      </ContentBox>
    </ScreenView>
  )
}
